import Panzoom from '@panzoom/panzoom';
import { createTrapper } from '~/lib/utils/focus-trapper';
export const createPanzoom = (els) => {
    const { trap, untrap } = createTrapper(els.modal);
    const options = {
        canvas: true,
        cursor: '',
        contain: 'outside',
        startScale: 2,
        step: 0.25,
        maxScale: 6,
    };
    const panzoom = Panzoom(els.img, options);
    const zoom = (delta) => {
        const r = els.frame.getBoundingClientRect();
        const scale = panzoom.getScale() * Math.exp(delta * options.step);
        panzoom.zoomToPoint(scale, {
            clientX: r.x + r.width / 2,
            clientY: r.y + r.height / 2,
        });
    };
    const zoomIn = () => {
        zoom(1);
    };
    const zoomOut = () => {
        zoom(-1);
    };
    const open = () => {
        els.main.dataset.modalOpen = 'true';
        document.body.dataset.panzoomModalOpen = 'true';
        els.modalContainer.inert = false;
        trap();
        requestAnimationFrame(addCloseListeners);
    };
    const close = () => {
        els.main.dataset.modalOpen = 'false';
        document.body.dataset.panzoomModalOpen = 'false';
        els.modalContainer.inert = true;
        untrap();
        removeCloseListeners();
    };
    const onClickOff = (ev) => {
        if (!(ev.target instanceof Node) || els.modal.contains(ev.target)) {
            return;
        }
        close();
    };
    const onEscape = (ev) => {
        if (ev.key !== 'Escape') {
            return;
        }
        close();
    };
    const addCloseListeners = () => {
        addEventListener('click', onClickOff);
        addEventListener('keydown', onEscape);
    };
    const removeCloseListeners = () => {
        removeEventListener('click', onClickOff);
        removeEventListener('keydown', onEscape);
    };
    els.zoomInBtn.addEventListener('click', zoomIn);
    els.zoomOutBtn.addEventListener('click', zoomOut);
    els.openBtn.addEventListener('click', open);
    els.closeBtn.addEventListener('click', close);
    els.frame.addEventListener('wheel', panzoom.zoomWithWheel, {
        passive: false,
    });
    return {
        panzoom,
        open,
        close,
        zoomIn,
        zoomOut,
    };
};
